export default {"src":"/_next/static/media/sphere-logomark.74cca414.svg","height":50,"width":50,"blurWidth":0,"blurHeight":0};